import moment from 'moment';
import CustomComponentActive from './CustomComponentActive';
import CustomOptionComponent from './CustomOptionComponent';
export const columnMeta = [
  {
    columnName: 'id',
    order: 1,
    locked: false,
    visible: false,
    multiOff: false,
    displayName: 'id',
  },
  {
    columnName: 'statusCode',
    order: 2,
    locked: false,
    visible: false,
    multiOff: false,
    displayName: 'code',
  },
  {
    columnName: 'createdDate',
    order: 3,
    locked: false,
    visible: true,
    displayName: 'Date',
    sortable: true,
    multiOff: false,
    cssClassName: 'column-when',
    sortDirectionCycle: ['desc', 'asc'],
  },
  {
    columnName: 'fromAccountName',
    order: 4,
    locked: false,
    visible: true,
    displayName: 'From',
    sortable: true,
    multiOff: false,
    customComponent: CustomComponentActive,
    cssClassName: 'column-from',
    sortDirectionCycle: ['asc', 'desc'],
  },
  {
    columnName: 'toAccountName',
    order: 5,
    locked: false,
    visible: true,
    displayName: 'To',
    sortable: true,
    multiOff: false,
    customComponent: CustomComponentActive,
    cssClassName: 'column-to',
    sortDirectionCycle: ['asc', 'desc'],
  },
  {
    columnName: 'amount',
    order: 6,
    locked: false,
    visible: true,
    sortable: false,
    displayName: 'Amount',
    multiOff: false,
    cssClassName: 'column-amount column--cursor-default',
  },
  {
    columnName: 'status',
    order: 7,
    locked: false,
    visible: true,
    displayName: 'Status',
    sortable: false,
    multiOff: false,
    customComponent: CustomComponentActive,
    cssClassName: 'column--cursor-default u-text-center',
  },
  {
    columnName: 'option',
    order: 8,
    locked: false,
    visible: true,
    displayName: 'Options',
    sortable: false,
    multiOff: false,
    customComponent: CustomOptionComponent,
    cssClassName: 'c-tbl__options column--cursor-default u-text-center',
  },
];
export const dateIntervalOptions = [
  {
    label: '1 week',
    value: '1 week',
  },
  {
    label: '2 weeks',
    value: '2 weeks',
  },
  {
    label: '1 month',
    value: '1 month',
  },
  {
    label: '3 months',
    value: '3 months',
  },
  {
    label: '6 months',
    value: '6 months',
  },
  {
    label: 'Custom Date',
    value: 'Custom Date',
  },
];
export const paymentStatusOptions = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Paid',
    value: 'Paid',
  },
  {
    label: 'Failed',
    value: 'Failed',
  },
  {
    label: 'Pending',
    value: 'Pending',
  },
  {
    label: 'Processing',
    value: 'Processing',
  },
  {
    label: 'Submitted',
    value: 'Submitted',
  },
  {
    label: 'Pending Submission',
    value: 'Pending Submission',
  },
  {
    label: 'Declined',
    value: 'Declined',
  },
  {
    label: 'Cancelled',
    value: 'Cancelled',
  },
];

export const badgeStatus = {
  Paid: 'tip',
  Processing: 'info',
  Pending: 'note',
  Failed: 'warning',
  Submitted: 'tip',
  'Pending Submission': 'note',
  Declined: 'warning',
  Cancelled: null,
};

export const sortDates = (a, b) => {
  if (moment(a).isValid() && moment(b).isValid)
    return moment.utc(a).diff(moment.utc(b));
  return 0;
};

export const sortByDate =
  (sortField = 'date') =>
  (sortDirection) => {
    if (sortDirection === 'asc') {
      return (a, b) => sortDates(a[sortField], b[sortField]);
    }
    return (a, b) => sortDates(b[sortField], a[sortField]);
  };

const sortString = (a = '', b = '') => {
  const lowerA = a.toLowerCase();
  const lowerB = b.toLowerCase();

  if (lowerA > lowerB) return 1;
  if (lowerA < lowerB) return -1;
  return 0;
};

export const sortByString = (sortField) => (sortDirection) => {
  if (sortDirection === 'asc') {
    return (a, b) => sortString(a[sortField], b[sortField]);
  }
  return (a, b) => sortString(b[sortField], a[sortField]);
};

const sortNumber = (a, b) => {
  const aNum = Number(a);
  const bNum = Number(b);

  if (aNum > bNum) return 1;
  if (aNum < bNum) return -1;
  return 0;
};

export const sortByAmount =
  (sortField = 'amount') =>
  (sortDirection) => {
    if (sortDirection === 'asc') {
      return (a, b) => sortNumber(a[sortField], b[sortField]);
    }
    return (a, b) => sortNumber(b[sortField], a[sortField]);
  };

export const sortCurrency = (a = '', b = '') => {
  if (a === '' && b === '') return 1;
  const numberA = Number(a.replace(/[^\d.]*/g, ''));
  const numberB = Number(b.replace(/[^\d.]*/g, ''));

  if (numberA > numberB) return 1;
  if (numberA < numberB) return -1;
  return 0;
};
